<template>
  <div  class="wrapper">
    <HeaderNav ref="header-nav" class="header-nav" />
    <div ref="wrapper" class="page-wrapper main-content">
      <SideBar />
      <!-- <dashboard-header class="d-none d-md-block" /> -->
      <!-- <HeaderNav class="d-md-none header-nav" /> -->
      <!-- <div class="d-none d-md-block pt-md-5"></div> -->
      <router-view />

      <BottomNav class="bottom-nav" />
      <Chatbot/>
    </div>
  </div>
</template>

<script>
//import your components here
import SideBar from "@/layouts/includes/dashboard/Sidebar.vue";
import BottomNav from '@/layouts/includes/frontend/BottomNav.vue';
import HeaderNav from './includes/frontend/HeaderNav.vue';
import Chatbot from "@/components/templates/Chatbot.vue";
import { gsapAnimations } from "@/services/gsapAnimations";



import $ from "jQuery";
window.$ = window.jQuery = $;

import bootstrapBundle from "@/assets/plugins/bootstrap/js/bootstrap.bundle.min.js";
window.bootstrapbundle = bootstrapBundle;

import nprogress from 'nprogress';
window.nprogress = nprogress;


import toastr from 'toastr';
window.toastr = toastr;

// SlimScroll
import slimScroll from "@/assets/plugins/slimscrollbar/jquery.slimscroll.min.js";
window.slimScroll = slimScroll;

// jQuery Mask
import mask from "@/assets/plugins/jquery-mask-input/jquery.mask.min.js";
window.mask = mask;

// Chart.js
import Chart from "@/assets/plugins/charts/Chart.min.js";
window.Chart = Chart;

// Custom scripts
import sleek from "@/assets/js/sleek.js";
window.sleek = sleek;

import chart from "@/assets/js/chart.js";
window.chart = chart;



import * as ladda from 'ladda';
window.ladda = ladda;

import moment from 'moment';
window.moment = moment;



import daterangepicker from 'daterangepicker';
window.daterangepicker = daterangepicker;

import SimpleJekyllSearch from 'simple-jekyll-search';
window.SimpleJekyllSearch = SimpleJekyllSearch;

import 'daterangepicker/daterangepicker.css';

// import dateRange from "@/assets/js/date-range.js";
import custom from "@/assets/js/custom.js";
// window.dateRange = dateRange;
window.custom = custom;


export default {
  components: {
    SideBar,
    BottomNav,
    Chatbot,
    HeaderNav,
  },
  mounted() {
    this.animatePageChange(); // initial load animation
  },

  methods: {
    animatePageChange() {
      gsapAnimations.animatePageChange(this.$refs.wrapper);
    }
  },
};
</script>

<style scoped>
  
.container-nzidoo {
  /* background: black; */
}
@media (max-width: 767px) {
  .main-content {
    padding-top: 60px !important;
  }

}
</style>
